// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__29moS","emails":"CreateEditClinics_emails__1gwdb","emailTagLabel":"CreateEditClinics_emailTagLabel__1l7vl"};